// extracted by mini-css-extract-plugin
export default {"loginWrapper":"AdminLoginPage_loginWrapper__8g4oF","loginContainer":"AdminLoginPage_loginContainer__0OGxw","errorMessage":"AdminLoginPage_errorMessage__bMfgW"};